export const SCHEDULE_TABS = [
  {
    // 训练负荷
    key: 'trainingLoad',
    name: 'R1001',
    type: 'default'
  },
  {
    // 运动时间
    key: 'workoutTime',
    name: 'R1002',
    type: 'default'
  },
  {
    // 运动距离
    key: 'distance',
    name: 'R1003',
    type: 'default'
  }
];
export const TABS_DATA = [
  {
    // 长期负荷
    name: 'SQ9005',
    key: '6WeekAvgTL',
    default: true,
    valueKey: 'actualCti'
  },
  {
    // 短期负荷
    name: 'SQ9006',
    key: '7DayAvgTL',
    default: false,
    valueKey: 'actualAti'
  },
  {
    // 负荷疲劳-> 负荷差值
    name: 'Y9081',
    key: 'tiredRateNew',
    default: true,
    valueKey: 'actualTrainingLoadRatio'
  }
];
export const TRAININGLOAD_TAB = {
  name: 'R1001',
  key: 'trainingLoad',
  default: true
};
export const DECORATE_LIST = [
  {
    // 周期阶段
    name: 'R2010',
    key: 'cyclePhase'
  },
  {
    // 标签
    name: 'R2011',
    key: 'label'
  }
];
